const getRiskScore = ({
  value,
  riskScoreRanges,
}: {
  value: string;
  riskScoreRanges: {
    name: string;
    value: string;
    from: number;
    to: number;
    description: string;
  }[];
}) => {
  const currentRange = riskScoreRanges.find(
    (item) => Number(value) >= item.from && item.to >= Number(value),
  )?.value;

  return currentRange;
};

export default getRiskScore;
